import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  SETTINGS_DETECTIONS_ORDER: {
    en: 'Detections order',
    de: 'Merkmal Anordnung',
  },
  SETTINGS_Clients: {
    en: 'Access control',
    de: 'Zugangskontrolle',
  },
  SETTINGS_ALL_Clients: {
    en: 'All Clients',
    de: 'Alle Mandanten',
  },
  SETTINGS_CustomerConfiguration: {
    en: 'Customer Configuration',
    de: 'Kunden Konfiguration',
  },
  SETTINGS_Settings: {
    en: 'Settings',
    de: 'Konfigurationen',
  },
  SETTINGS_MustHave: {
    en: 'Must Have',
    de: 'Verpflichtend',
  },
  SETTINGS_NiceToHave: {
    en: 'Nice to have',
    de: 'Sonstige',
  },
  SETTINGS_ClientName: {
    en: 'Customer Name',
    de: 'Kundenname',
  },
  SETTINGS_Autoprocessable: {
    en: 'Autoprocessable',
    de: 'Automatische Verarbeitung',
  },
  SETTINGS_Splitting: {
    en: 'Splitting',
    de: 'Stapeltrennung',
  },
  SETTINGS_ReleaseStep: {
    en: 'Release Step',
    de: 'Freigabe Schritt',
  },
  SETTINGS_On: {
    en: 'ON',
    de: 'EIN',
  },
  SETTINGS_Off: {
    en: 'OFF',
    de: 'AUS',
  },
  SETTINGS_Forced: {
    en: 'FORCED',
    de: 'IMMER',
  },
  SETTINGS_Name: {
    en: 'Name',
    de: 'Name',
  },
  SETTINGS_Description: {
    en: 'Description',
    de: 'Beschreibung',
  },
  SETTINGS_Optional_name: {
    en: 'Optional user name...',
    de: 'Optionaler Benutzername',
  },
  SETTINGS_Optional_description: {
    en: 'Optional description...',
    de: 'Optionale Beschreibung',
  },
};
